module.exports = __webpack_public_path__ + "static/media/cancel-icon.865ca46f.svg";